import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { useAuthStore } from '@/store/AuthPinia';

const pinia = createPinia();
createApp(App).use(router).use(store).use(pinia).use(VueToast, { position: 'bottom', queue: true }).mount('#app');
// This must stay here (after pinia has been used)
const authStore = useAuthStore();
// Routes basic frontend auth
router.beforeEach(async (to, from, next) => {

    // If the user interrupted the tutorial by clicking a route link exit it.
    if (window.introSelect) {
        window.introSelect.exit(true);
        window.introSelect = null;
    }

    // Redirect to email verification added in Interceptor, to prevent infinite calling when rendering VerificationNotice route prevent calling 'getCurrentUser'
    if (['VerificationNotice', 'VerificationConfirmation'].includes(to.name)) {
        next();
        return;
    }

    // Accessing private route (need to be at least authenticated)
    // Keep the await here otherwise it will break
    const user = await authStore.getCurrentUser(false).then(() => {
        // Accessing public route (allowed for everyone) and not a logged in user trying to access (register, login, or forgot password)
        if (to.meta.public && !(authStore.authenticated && to.meta.layout == 'AppLayoutAuth')) {
            next();
            return; // To avoid duplicate next calls
        }
        else if (authStore.authenticated && to.meta.layout == 'AppLayoutAuth') { // A logged in user trying to access auth routes
            if (to.query?.redirectAfter) {
                // Get the url to redirect to after login
                const fullUrl = decodeURI(to.query?.redirectAfter);
                const parsedURL = new URL(fullUrl);
                const path = '/' + parsedURL.pathname.slice(1);
                // Redirect to the url after login
                next(path);
                return;
            }
            next({ name: 'TalentCloudsIndex', 'currentView': 'grid' });
            return;
        }

        if (!authStore.authenticated) // A guest trying to access private route
        {
            next({ name: 'Login', query: to.query });
            return;
        }
        // A user trying to access a route that requires a specific role
        if (to.meta.requiredRoles && !authStore.currentUserHasPermission(to.meta.requiredRoles)) {
            next({ name: 'TalentCloudsIndex', 'currentView': 'grid' });
            return;
        }
        // A beta user trying to access a coming soon route
        if (authStore.isBeta && to.meta.soon) {
            next({ name: 'TalentCloudsIndex', 'currentView': 'grid' });
            return;
        }

        // A user accessing a private route
        next();
        if (to.meta.bodyBackground) {
            document.body.style.backgroundColor = to.meta.bodyBackground;
        }else{
            document.body.style.backgroundColor = "#fff";
        }
        return;

    }).catch((e) => {
        // Won't be reached because the exceptions are handled in the store, leave it here in case the store changes in the future
        // Don't try to redirect to login or remove this console log because if an error is throwen for any reason
        // you can endup with untraceable Vue router infinite loop
        console.log(e);
        next();
        return;
    });

});

